import axios from 'axios'
import Cookies from 'js-cookie'
import { Loading, Message } from 'element-ui'
import store from '../store'
import router from '../router'

const api = axios.create({
  baseURL: process.env.VUE_APP_BASE_API // url = base url + request url
})

api.interceptors.request.use(
  (config) => ({
    ...config,
    headers: {
      'content-type': 'application/json',
      Authorization: Cookies.get('token')
    }
  }),
  (error) => Promise.reject(error)
)

api.interceptors.response.use(
  ({ data: response }) => {
    const {
      success, data, msg
    } = response
    if (!success) throw new Error(msg)
    return {
      data,
      success
    }
  },
  (error) => Promise.reject(error)
)

async function Ajax(method = '', url, params, cusKey) {
  const loadingInstance = Loading.service({ fullscreen: true })
  try {
    const key = cusKey || method === 'get' ? 'params' : 'data'
    const result = await api({
      url,
      method,
      [key]: params
    })
    loadingInstance.close()
    return result
  } catch (error) {
    loadingInstance.close()
    if (error.response) {
      const code = error.response.status
      if (code === 401) {
        store.commit('setCookie')
        store.commit('setLoginStatus', false)
        router.push({ name: 'Home' })
      } else {
        Message({
          type: 'error',
          message: error.response.data.message,
          duration: 1500
        })
      }
    } else {
      Message({
        type: 'error',
        message: error,
        duration: 1500
      })
    }
  }
}

export default Ajax
